import {TransactionSchema} from './TransactionSchema';

export const getOrderResultSign = (order: TransactionSchema): '+' | '-' | '' => {
    const {group, type} = order;

    if (isSell(order)) {
        return '-';
    }

    if (type === 'token_migrate') {
        return '';
    }
    if (/exchange|incomings|unit_purchase/.test(group)) {
        return '+';
    }
    if (group === 'outgoings') {
        return '-';
    }
    return '';
};

export const isSell = (order: TransactionSchema) => {
    return order.group === 'exchange' && /sell|token_sell/.test(order.type);
};
